export type ReplayFileSource = {
  type?: string | null;
  url?: string | null;
};

export const isReplayFileSource = (stream: ReplayFileSource): boolean => {
  const normalizedType = (stream.type ?? "").trim().toLowerCase();
  if (normalizedType === "file" || normalizedType === "pcap") {
    return true;
  }

  const normalizedUrl = (stream.url ?? "").trim().toLowerCase();
  return normalizedUrl.startsWith("file://") || normalizedUrl.startsWith("pcap://");
};
